import { render } from "./VirtualScrollingList.vue?vue&type=template&id=ca16ac08&ts=true"
import script from "./VirtualScrollingList.vue?vue&type=script&lang=ts"
export * from "./VirtualScrollingList.vue?vue&type=script&lang=ts"

import "./VirtualScrollingList.vue?vue&type=style&index=0&id=ca16ac08&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__